import _ from 'lodash';
import { SET_MENU_ACTIVATED } from './actions';

const initialState = {
  currentUser: null,
  ownerUser: null,
  token: null,
  buttonLoading: false,
  otpSession: '',
  sessionId: false,
  selectedCurrency: '',
  progressMsg: false,
  firstLogin: false,
  menusActivated: [],
};

export default function GlobalReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      if (!_.isMatch(state.currentUser, action.user)) {
        return {
          ...state,
          currentUser: action.user,
        };
      } else {
        return {
          ...state,
        };
      }
    case 'SET_OWNER_USER':
      return {
        ...state,
        ownerUser: action.user,
      };
    case 'SET_FIRSTLOGIN':
      return {
        ...state,
        firstLogin: action.login,
      };

    case 'SET_CURRENCY':
      if (!_.isMatch(state.selectedCurrency, action.currency)) {
        return {
          ...state,
          selectedCurrency: action.currency,
        };
      } else {
        return {
          ...state,
        };
      }

    case 'SHOW_BTN_LOADING':
      return {
        ...state,
        buttonLoading: true,
      };

    case 'HIDE_BTN_LOADING':
      return {
        ...state,
        buttonLoading: false,
      };

    case 'SET_AUTH_TOKEN':
      localStorage.setItem('tokenAdmin', action.token);
      return {
        ...state,
        token: action.token,
      };

    case 'SET_OTP_SESSION':
      return {
        ...state,
        otpSession: action.sessionId,
      };

    case 'SET_SESSION_ID':
      return {
        ...state,
        sessionId: action.sessionId,
      };

    case 'SHOW_PROGRESS_MSG':
      return { ...state, progressMsg: action.payload };

    case SET_MENU_ACTIVATED:
      return { ...state, menusActivated: action.payload || [] };

    case 'LOGOUT': {
      // console.log("GLOBAL LOGOUT")
      localStorage.clear();
      sessionStorage.clear();
      // window.location.reload()
      return initialState;
    }

    default:
      return state;
  }
}
